import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

/** Route guard for customer account pages: waits for the session check, then requires sign-in. */
export default function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  if (status === 'unknown') return <p role="status">Loading account…</p>;
  return status === 'authed' ? <Outlet /> : <Navigate to="/login" replace />;
}
